import { Loader } from '@fukuri-admins/ui/common';
import { Suspense } from 'react';
import { RootRedirect } from '~/features/RootRedirect';

/**
 * ROOT（`/`）画面の Screen
 *
 * レイアウトを持たず、パートナーの API 連携機能フラグに応じたリダイレクトのみを行う。
 * フラグ取得が suspense 前提のため、Suspense 境界はここで張る。
 */
export const Screen: React.FC = () => (
  <Suspense fallback={<Loader />}>
    <RootRedirect />
  </Suspense>
);
